module.exports = __webpack_public_path__ + "img/e0409b1.png";